import React, {useState} from 'react'
import Greeting from '../../../components/Greeting'
import {corporateContactInfoInputs, corporateContactInfoSchema, getDefault, individualContactInfoInputs, individualContactInfoSchema} from '../../../services/reg-inputs'
import {useFormik} from 'formik'
import {useDispatch, useSelector} from 'react-redux'
import CustomInput from '../../../components/CustomInput'
import CustomButton from '../../../components/CustomButton'
import RightArrIcon from '../../../components/Icons/RightArrIcon'
import axios from 'axios'
import {BURL} from '../../../services/base'
import {setProfile} from '../../../slices/userSlice'
import {toast} from 'react-toastify'
import ProfileGoTo from '../../../components/ProfileGoTo'

const EmploymentDetails = () => {
	const {data, customer} = useSelector(state => state.profile);
	const [inProgress, setInProgress] = useState(false);
	const isCORP = (customer?.label === "CORP");

	const dispatch = useDispatch()
	const initialValues = getDefault((isCORP ? corporateContactInfoInputs : individualContactInfoInputs), {...data, ...customer});
	const contactInfo = useFormik({
		validationSchema: isCORP ? corporateContactInfoSchema : individualContactInfoSchema,
		initialValues,
		onSubmit: (values) => {
			const body = {...data, ...customer, ...values}
			setInProgress(true);
			axios.post(`${BURL}edit-customer`, {...body, customer_id: customer.id, rm_id: customer.rm_id}).then(res => {
				if (!res?.data?.success) throw new Error(res);
				axios.post(`${BURL}get-customer`).then(res => {
					if (!res?.data?.success) throw new Error(res);
					setInProgress(false);
					toast.success("Updated successfully")
					// successRes("Updated successfully");
					dispatch(setProfile(res.data.message));
				}).catch(err => {
					toast.error("Can't fetch updated user profile")
				})
			}).catch(err => {
				setInProgress(false);
				if (err?.response?.data) {
					toast.error(err?.response?.data?.message)
				} else {
					toast.error("An error occured")
				}
			})
		}
	})

	return (
		<div>
			<Greeting showBack primaryBack noPre head={isCORP ? 'Contact Details' : `Employment and Others`} sub={'Please provide your employment details'} />
			<div>
				<form onSubmit={contactInfo.handleSubmit} className='flex w-full lg:w-2/3 xl:w-1/2 flex-wrap'>
					{(isCORP ? corporateContactInfoInputs : individualContactInfoInputs).map((inputProps, i) => (
						<div key={i} className={`px-3 ${inputProps.class ? inputProps.class : 'lg:w-1/2'} w-full`}>
							<CustomInput className="min-w-full" key={i} {...inputProps} formik={contactInfo} initialValues={initialValues} />
						</div>
					))}
					<div className='flex space-x-2 py-6 w-full px-3'>
						<CustomButton type="submit" className="w-full" loading={inProgress}>
							<span>Update Details</span>
							{!inProgress && <RightArrIcon />}
						</CustomButton>
					</div>
					<div className='flex justify-between gap-3 py-4 w-full px-3'>
						<ProfileGoTo prev to={"/profile/banks"} />
						<ProfileGoTo next to={"/profile/docs"} />
					</div>
				</form>
			</div>
		</div>
	)
}

export default EmploymentDetails